import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgBookOpen = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M5.175 18.374c2.376.171 4.444 1.143 5.663 1.85.721.417 1.603.417 2.324 0 1.219-.707 3.287-1.679 5.663-1.85 1.216-.087 2.175-1.06 2.175-2.279V5.754c0-1.372-1.2-2.424-2.564-2.275-2.211.242-4.122 1.146-5.274 1.814a2.31 2.31 0 0 1-2.324 0C9.686 4.626 7.775 3.722 5.564 3.48 4.2 3.33 3 4.382 3 5.754v10.341c0 1.219.96 2.192 2.175 2.28M12 5.879V20.48"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M17.761 3.617V9.34l-.547-.363a1.53 1.53 0 0 0-1.694 0l-.547.363V4.398"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgBookOpen);
export default ForwardRef;
